import { render } from "./TipShareRuleTable.vue?vue&type=template&id=75acd158"
import script from "./TipShareRuleTable.vue?vue&type=script&lang=js"
export * from "./TipShareRuleTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__